<!-- <div class="d-flex flex-column" [formGroup]="phoneFormGroup">
  <mat-label *ngIf="label"
    >{{ label }} <span *ngIf="required" class="required">*</span></mat-label
  >
  <div class="d-flex" style="margin-bottom: -15px">
    <mat-form-field appearance="outline" class="w-px-120">
      <mat-select [formControlName]="formControlName1">
        <div class="inner-add-on left-add-on my-3" [formGroup]="filterForm">
            <input type="search" formControlName="keyword" class="form-control" placeholder="Search" />
            <svg-icon class="inner-icon left" svgClass="placeholder-icon" src="assets/icons/search-grey.svg"></svg-icon>
        </div>
        <mat-select-trigger>
          <div class="d-flex align-items-center">
            <svg-icon
              src="{{ phoneSelected[index]?.icon }}"
              class="icon-flag"
            ></svg-icon>
            <div>+{{ phoneSelected[index]?.phoneIsoCode }}</div>
          </div>
        </mat-select-trigger>
        @for (item of filteredList; track item) {
        <mat-option [value]="item.num_code">
          <div class="d-flex align-items-center">
            <svg-icon
              src="assets/icons/flag/{{ item.alpha_2_code.toLowerCase() }}.svg"
              class="icon-flag"
            ></svg-icon>
            <div>+{{ item?.num_code }}</div>
          </div></mat-option
        >
        }
      </mat-select>
    </mat-form-field>
    <input
      type="text"
      [formControlName]="formControlName"
      class="h-px-46 ml-px-16 w-px-267"
    />
  </div>
</div> -->
<form #f="ngForm" [formGroup]="phoneFormGroup">
  <mat-label>Téléphone <span class="required">*</span></mat-label>

  <ngx-intl-tel-input
    [cssClass]="'custom'"
    [preferredCountries]="[CountryISO.France]"
    [enableAutoCountrySelect]="false"
    [enablePlaceholder]="true"
    [searchCountryFlag]="true"
    [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
    [selectFirstCountry]="false"
    [selectedCountryISO]="CountryISO.Tunisia"
    [numberFormat]="PhoneNumberFormat.National"
    [maxLength]="15"
    [phoneValidation]="true"
    [inputId]="'numtel'"
    formControlName="{{ formControlName }}"
  ></ngx-intl-tel-input>
</form>
